import React, { useEffect, useState, useMemo } from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import ReactApexChart from "react-apexcharts";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import dayjs from "dayjs";
import { company_short_name } from "../../../environment";
import { showBasicAlert } from "../../../core/common/useAlert";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import api from "../../../services/api";
import Loader from "../../../core/common/loader";
import { FaArrowUp, FaArrowDown } from "react-icons/fa";
import { getAbbreviation } from "../../../core/common/common_functions";
import { ApexOptions } from "apexcharts";
import CommonSelect from "../../../core/common/commonSelect";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";

const DealsDashboard = () => {
  const navigate = useNavigate();
  const signature = localStorage.getItem("signature");
  const routes = all_routes;
  const [isLoading, setIsLoading] = useState(false);
  const [leadData, setleadData] = useState<any[]>([]);
  const [getDashboardDetails, setgetDashboardDetails] = useState<
    Record<string, any>
  >({});
  const [selectedForm, setSelectedForm] = useState(null);
  const [data, setData] = useState<any[]>([]);

  const [companyList, setCompanyList] = useState<any[]>([]);

  useEffect(() => {
    setIsLoading(true);
    const getCompanyList = async () => {
      try {
        const [companyList] = await Promise.all([
          api.post("userService/getAllCompanyList", {
            signature,
          }),
        ]);

        setCompanyList(companyList.data.data.data);
      } catch (err) {
        console.error("Error fetching dashboard data:", err);
      }
    };
    getCompanyList();
  }, []);

  var initialFormDataChooseCompany = {
    signature: signature,
    companyName: "Select Company",
    companyId: "",
    companyType: "Dashboard",
  };
  const [formDataCompanyChoose, setformDataCompanyChoose] = useState(
    initialFormDataChooseCompany
  );

  const companyChoose = [
    ...companyList?.map((company: any) => ({
      value: company.id,
      label: company.name + " - " + company.type,
    })),
  ];

  useEffect(() => {
    if (companyList.length) {
      handleCompanyChange({
        value: companyList?.[0]?.id,
        label: companyList?.[0]?.name + "-" + companyList?.[0]?.type,
      });
    }
  }, [companyList]);

  const handleCompanyChange = async (selectedOption: any) => {
    if (!selectedOption) return;
    const newFormData = {
      companyId: selectedOption.value,
      companyName: selectedOption.label.split("-")[0].trim(),
      companyType: selectedOption.label.split("-")[1].trim(),
    };

    setformDataCompanyChoose((prev: any) => ({
      ...prev,
      ...newFormData,
    }));

    const [getLeadForms] = await Promise.all([
      api.post("leadService/getLeadFormsByCompany", {
        signature,
        company_id: newFormData.companyId,
        company_type: newFormData.companyType,
      }),
    ]);
    setData(getLeadForms.data.data.data);
  };

  useEffect(() => {
    if (data.length && formDataCompanyChoose.companyId != "") {
      const firstValidLeadForm = data?.find(
        (leadForm: any) => leadForm.deal_pipeline_id !== null
      );

      if (firstValidLeadForm) {
        handleLeadFormChange({
          value: `${firstValidLeadForm.deal_pipeline_id}-${firstValidLeadForm.key}`,
          label: firstValidLeadForm.LeadFormName,
        });
      } else {
        handleLeadFormChange({
          value: "",
          label: "No Lead Form",
        });
      }
    } else {
      handleLeadFormChange({
        value: "",
        label: "No Lead Form",
      });
    }
  }, [data]);

  const leadFormChoose = [
    ...data
      ?.filter((leadForm: any) => leadForm.deal_pipeline_id !== null)
      .map((leadForm: any) => ({
        value: `${leadForm.deal_pipeline_id}-${leadForm.key}`,
        label: leadForm.LeadFormName,
      })),
  ];

  var initialFormDataChooseForm = {
    signature: signature,
    pipeline_id: "",
    form_name: "",
    form_id: "",
  };
  const [formDataFormChoose, setformDataFormChoose] = useState(
    initialFormDataChooseForm
  );

  const handleLeadFormChange = async (selectedOption: any) => {
    try {
      if (!selectedOption || selectedOption.value == "") {
        const newFormData = {
          pipeline_id: selectedOption.value?.split("-")[0],
          form_name: selectedOption.label,
          form_id: selectedOption.value?.split("-")[1],
        };
        setformDataFormChoose((prev: any) => ({
          ...prev,
          ...newFormData,
        }));
        return;
      }
      const newFormData = {
        pipeline_id: parseInt(selectedOption.value?.split("-")[0]),
        form_name: selectedOption.label,
        form_id: parseInt(selectedOption.value?.split("-")[1]),
      };
      setformDataFormChoose((prev: any) => ({
        ...prev,
        ...newFormData,
      }));
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    if (
      formDataFormChoose.pipeline_id == "" ||
      formDataFormChoose.pipeline_id == null ||
      formDataCompanyChoose.companyId == ""
    ) {
      setIsLoading(false)
      return;
    }
    const fetchDashboardData = async () => {
      await updateUI();
    };
    fetchDashboardData();
  }, [formDataFormChoose]);

  const updateUI = async () => {
    setIsLoading(true);
    const [DealDashboard, getAllDealsResponse] = await Promise.all([
      api.post("leadService/dealDashboard", {
        signature,
        company_id: formDataCompanyChoose.companyId,
        company_type: formDataCompanyChoose.companyType,
        pipeline_id: formDataFormChoose.pipeline_id,
        form_id: formDataFormChoose.form_id,
      }),
      api.post("leadService/getAllDealsResponseDashboard", {
        signature,
        company_id: formDataCompanyChoose.companyId,
        company_type: formDataCompanyChoose.companyType,
        form_id: formDataFormChoose.form_id,
      }),
    ]);

    const top5leads = getAllDealsResponse.data.data.data?.slice(0, 5);
    setleadData(top5leads);
    setgetDashboardDetails(DealDashboard.data.data.data);
    newLeadData(DealDashboard.data.data.data.sixweekdeals);
    setSelectedForm(DealDashboard.data.data.data?.dealStages[0]?.name);

    setIsLoading(false);
  };

  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, "0"); // Month is zero-based, so we add 1
  const day = String(today.getDate()).padStart(2, "0");
  const formattedDate = `${month}-${day}-${year}`;
  const defaultValue = dayjs(formattedDate);

  const [isHoveredTotalDeal, setisHoveredTotalDeal] = useState(false);
  const [isHoveredTodayDeal, setIsHoveredTodayDeal] = useState(false);
  const [isHoveredFollowUp, setisHoveredFollowUp] = useState(false);
  const [isHoveredTotalCall, setisHoveredTotalCall] = useState(false);

  //Today Follow Up Start
  const [checkedIdsFollowup, setCheckedIdsFollowup] = useState<number[]>([]);
  const [visibleFollowUps, setVisibleFollowUps] = useState<any[]>([]);
  const [visibleFollowUpsAll, setVisibleFollowUpsAll] = useState<any[]>([]);
  useEffect(() => {
    if (getDashboardDetails?.total_follow_up_list_today) {
      const initial = getDashboardDetails?.total_follow_up_list_today?.slice(
        0,
        5
      );
      setVisibleFollowUps(initial);

      const initialAll = getDashboardDetails?.total_follow_up_list_today;
      setVisibleFollowUpsAll(initialAll);
    }
  }, [getDashboardDetails]);

  const handleMarkAsDone = async (id: number) => {
    try {
      // Mark locally
      setCheckedIdsFollowup((prev) => [...prev, id]);

      try {
        var [result] = await Promise.all([
          api.post("leadService/updateLeadFollowUp", { signature, id }),
        ]);
        showBasicAlert(result.data.message[0].msg);

        setCheckedIdsFollowup([]);

        setVisibleFollowUps((prevVisible) => {
          const updatedVisible = prevVisible.filter(
            (item) => item.followup_id !== id
          );

          // Find next item that is NOT in checked list or already visible
          const remaining =
            getDashboardDetails.total_follow_up_list_today.filter(
              (item: any) =>
                !checkedIdsFollowup.includes(item.followup_id) &&
                !updatedVisible.some(
                  (v) => v.followup_id === item.followup_id
                ) &&
                item.followup_id !== id // exclude current checked too
            );

          if (remaining.length > 0) {
            updatedVisible.push(remaining[0]);
          }

          return updatedVisible;
        });
      } catch (e) {}
    } catch (error: any) {
      showBasicAlert(error.data.message[0].msg);
    }
  };
  const handleMarkAsDoneAll = async (id: number) => {
    try {
      // Mark locally
      setCheckedIdsFollowup((prev) => [...prev, id]);

      try {
        var [result] = await Promise.all([
          api.post("leadService/updateLeadFollowUp", { signature, id }),
        ]);
        showBasicAlert(result.data.message[0].msg);

        setCheckedIdsFollowup([]);

        setVisibleFollowUpsAll((prevVisible) => {
          const updatedVisible = prevVisible.filter(
            (item) => item.followup_id !== id
          );

          // Find next item that is NOT in checked list or already visible
          const remaining =
            getDashboardDetails.total_follow_up_list_today.filter(
              (item: any) =>
                !checkedIdsFollowup.includes(item.followup_id) &&
                !updatedVisible.some(
                  (v) => v.followup_id === item.followup_id
                ) &&
                item.followup_id !== id // exclude current checked too
            );

          if (remaining.length > 0) {
            updatedVisible.push(remaining[0]);
          }

          return updatedVisible;
        });
      } catch (e) {}
    } catch (error: any) {
      showBasicAlert(error.data.message[0].msg);
    }
  };
  //Today Follow Up end

  //Totoal Follow Up Start
  const [visibleFollowUpsTotal, setVisibleFollowUpsTotal] = useState<any[]>([]);

  useEffect(() => {
    if (getDashboardDetails?.total_follow_up_pending_list) {
      const initialAll = getDashboardDetails?.total_follow_up_list;
      setVisibleFollowUpsTotal(initialAll);
    }
  }, [getDashboardDetails]);
  //Total Follow Up end

  //Pending Follow Up Start
  const [checkedIdsPending, setCheckedIdsPending] = useState<number[]>([]);
  const [visibleFollowUpsPending, setVisibleFollowUpsPending] = useState<any[]>(
    []
  );
  const [visibleFollowUpsPendingAll, setVisibleFollowUpsPendingAll] = useState<
    any[]
  >([]);

  useEffect(() => {
    if (getDashboardDetails?.total_follow_up_pending_list) {
      const initial = getDashboardDetails?.total_follow_up_pending_list?.slice(
        0,
        5
      );
      setVisibleFollowUpsPending(initial);

      const initialAll = getDashboardDetails?.total_follow_up_pending_list;
      setVisibleFollowUpsPendingAll(initialAll);
    }
  }, [getDashboardDetails]);

  const handleMarkAsDonePending = async (id: number) => {
    try {
      // Mark locally
      setCheckedIdsPending((prev) => [...prev, id]);

      try {
        var [result] = await Promise.all([
          api.post("leadService/updateLeadFollowUp", { signature, id }),
        ]);
        showBasicAlert(result.data.message[0].msg);

        setCheckedIdsPending([]);

        setVisibleFollowUpsPending((prevVisible) => {
          const updatedVisible = prevVisible.filter(
            (item) => item.followup_id !== id
          );

          // Find next item that is NOT in checked list or already visible
          const remaining =
            getDashboardDetails?.total_follow_up_pending_list?.filter(
              (item: any) =>
                !checkedIdsPending.includes(item.followup_id) &&
                !updatedVisible.some(
                  (v) => v.followup_id === item.followup_id
                ) &&
                item.followup_id !== id // exclude current checked too
            );

          if (remaining.length > 0) {
            updatedVisible.push(remaining[0]);
          }

          return updatedVisible;
        });
      } catch (e) {}
    } catch (error: any) {
      showBasicAlert(error.data.message[0].msg);
    }
  };
  const handleMarkAsDonePendingAll = async (id: number) => {
    try {
      // Mark locally
      setCheckedIdsPending((prev) => [...prev, id]);

      try {
        var [result] = await Promise.all([
          api.post("leadService/updateLeadFollowUp", { signature, id }),
        ]);
        showBasicAlert(result.data.message[0].msg);

        setCheckedIdsPending([]);

        setVisibleFollowUpsPendingAll((prevVisible) => {
          const updatedVisible = prevVisible.filter(
            (item) => item.followup_id !== id
          );

          // Find next item that is NOT in checked list or already visible
          const remaining =
            getDashboardDetails?.total_follow_up_pending_list?.filter(
              (item: any) =>
                !checkedIdsPending.includes(item.followup_id) &&
                !updatedVisible.some(
                  (v) => v.followup_id === item.followup_id
                ) &&
                item.followup_id !== id // exclude current checked too
            );

          if (remaining.length > 0) {
            updatedVisible.push(remaining[0]);
          }

          return updatedVisible;
        });
      } catch (e) {}
    } catch (error: any) {
      showBasicAlert(error.data.message[0].msg);
    }
  };
  //Pending Follow Up end

  //Pipeline stages
  const formNames: string[] = Array.from(
    new Set(
      getDashboardDetails?.dealStages?.map((company: any) => company.name) || []
    )
  );

  const [pipeline_chart, setPipelineChart] = useState<any>({
    series: [{ name: "", data: [] }],
    chart: { type: "bar", height: 280 },
    plotOptions: {
      bar: {
        borderRadius: 0,
        horizontal: true,
        distributed: true,
        barHeight: "80%",
        isFunnel: true,
      },
    },
    colors: ["#F26522", "#F37438", "#F5844E", "#F69364", "#F7A37A", "#F9B291"],
    dataLabels: {
      enabled: true,
      formatter: function (
        val: any,
        opt: {
          w: { globals: { labels: { [x: string]: any } } };
          dataPointIndex: string | number;
        }
      ) {
        return opt.w.globals.labels[opt.dataPointIndex];
      },
      dropShadow: {
        enabled: true,
      },
    },
    title: { align: "top" },
    xaxis: { categories: [] },
    legend: { show: false },
  });
  const [pipelineStagesData, setpipelineStagesData] = useState<any[]>([]);

  useEffect(() => {
    if (!selectedForm) return;

    const PipelineStages = async () => {
      try {
        const stages =
          getDashboardDetails?.dealStages?.find(
            (company: any) => company.name === selectedForm
          )?.stages_data || [];
        const chartData = stages.map((stage: any) => stage.stage_count);
        const chartCategories = stages.map(
          (stage: any) => `${stage.pipeline_char} : ${stage.stage_count}`
        );
        setpipelineStagesData(chartCategories);

        setPipelineChart((prev: any) => ({
          ...prev,
          series: [{ name: "", data: chartData }],
          xaxis: { categories: chartCategories },
        }));
      } catch (err) {
        console.error("Error fetching dashboard data:", err);
      }
    };

    PipelineStages();
  }, [selectedForm]);

  const [selectedYear, setSelectedYear] = useState(
    new Date().getFullYear().toString()
  );
  const currentYear = new Date().getFullYear();
  const startYear = 2018;
  const yearRanges = [];

  for (let year = currentYear; year >= startYear; year--) {
    yearRanges.push(`${year}`);
  }
  const [isLoadingStagesYear, setisLoadingStagesYear] = useState(false);
  const [DealStagesYearData, setDealStagesYearData] = useState<any[]>([]);
  const [filteredDataStagesYear, setfilteredDataStagesYear] = useState<any[]>(
    []
  );

  useEffect(() => {
    if (!selectedForm || !selectedYear) return;

    const PipelineStages = async () => {
      try {
        setisLoadingStagesYear(true);
        const [data] = await Promise.all([
          api.post("leadService/dealDashboardPipeline", {
            signature,
            form_name: selectedForm,
            year: selectedYear.trim(),
          }),
        ]);

        const pipeline = data.data.data.data.dealStagePipeline;
        const monthNames = [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ];
        const stageMap: { [stage: string]: number[] } = {};

        if (pipeline.length > 0) {
          setfilteredDataStagesYear(
            getDashboardDetails?.dealStages?.find(
              (company: any) => company.name === selectedForm
            )?.stages_data || []
          );
        } else {
          setfilteredDataStagesYear([]);
        }

        pipeline.forEach((item: any) => {
          const monthIndex = parseInt(item.month) - 1;
          const stage = item.pipeline_char;
          const count = parseInt(item.total);

          if (!stageMap[stage]) {
            stageMap[stage] = Array(12).fill(0);
          }

          stageMap[stage][monthIndex] += count;
        });

        const series = Object.keys(stageMap).map((stage) => ({
          name: stage,
          data: stageMap[stage],
        }));

        // Update chart config
        setRevenueIncome({
          chart: {
            height: 230,
            type: "bar",
            stacked: true,
            toolbar: {
              show: false,
            },
            events: {
              dataPointSelection: async (
                event: any,
                chartContext: any,
                config: any
              ) => {
                const clickedIndex = config.dataPointIndex;
                const seriesIndex = config.seriesIndex;
                const label =
                  config.w.config.xaxis.categories?.[clickedIndex] ?? "Unknown";
                const series = config.w.config.series;
                const value = series?.[seriesIndex]?.data?.[clickedIndex] ?? 0;
                const seriesName =
                  series?.[seriesIndex]?.name ?? "Unnamed Series";

                const year = parseInt(selectedYear, 10);

                // 🗓 Convert label (e.g. 'March') to date range
                const monthIndex = new Date(`${label} 1, ${year}`).getMonth(); // 0-based
                const startDate = new Date(year, monthIndex, 1);
                const endDate = new Date(year, monthIndex + 1, 0); // last day of the month

                const formatDate = (date: Date) =>
                  date.toISOString().split("T")[0];
                const formattedStart = formatDate(startDate);
                const formattedEnd = formatDate(endDate);

                try {
                  navigate(routes.dealsList, {
                    state: {
                      selectedLabel:
                        seriesName + "," + formattedStart + "," + formattedEnd,
                      type: "pipeline_stage",
                    },
                  });
                } catch (err) {
                  console.error("Error fetching dashboard data:", err);
                }
              },
            },
          },
          colors: ["#FF6F28", "#6F42C1", "#20C997"], // Add more if needed
          responsive: [
            {
              breakpoint: 480,
              options: {
                legend: {
                  position: "bottom",
                  offsetX: -10,
                  offsetY: 0,
                },
              },
            },
          ],
          plotOptions: {
            bar: {
              borderRadius: 5,
              borderRadiusWhenStacked: "all",
              horizontal: false,
              endingShape: "rounded",
            },
          },
          series,
          xaxis: {
            categories: monthNames,
            labels: {
              style: {
                colors: "#6B7280",
                fontSize: "13px",
              },
            },
          },
          yaxis: {
            show: false,
            min: 0,
            labels: {
              offsetX: -15,
              style: {
                colors: "#6B7280",
                fontSize: "13px",
              },
              formatter: function (value: string) {
                return value + "K";
              },
            },
          },
          grid: {
            borderColor: "transparent",
            strokeDashArray: 5,
            padding: {
              left: -8,
            },
          },
          legend: {
            show: true,
          },
          dataLabels: {
            enabled: false,
          },
          tooltip: {
            y: {
              formatter: function (val: number) {
                return val + " Leads";
              },
            },
          },
          fill: {
            opacity: 1,
          },
        });
        setisLoadingStagesYear(false);
      } catch (err) {
        console.error("Error fetching dashboard data:", err);
      }
    };

    PipelineStages();
  }, [selectedYear, selectedForm]);

  const [showAllStages, setShowAllStages] = useState(false);

  const MAX_VISIBLE_CARDS = 6;

  const visibleStages = showAllStages
    ? filteredDataStagesYear
    : filteredDataStagesYear?.slice(0, MAX_VISIBLE_CARDS);

  const [revenueIncome, setRevenueIncome] = useState<any>(null);

  //Recent Activites Start
  const [visibleRecentActivity, setvisibleRecentActivity] = useState<any[]>([]);
  const [visibleRecentActivityAll, setvisibleRecentActivityAll] = useState<
    any[]
  >([]);
  useEffect(() => {
    if (getDashboardDetails?.recentActivities) {
      const initial = getDashboardDetails?.recentActivities?.slice(0, 5);
      setvisibleRecentActivity(initial);

      const initialAll = getDashboardDetails?.recentActivities;
      setvisibleRecentActivityAll(initialAll);
    }
  }, [getDashboardDetails]);
  //Recent Activites End

  interface HeatmapDataPoint {
    x: string;
    y: number;
    color?: string;
  }

  interface HeatmapSeries {
    name: string;
    data: HeatmapDataPoint[];
  }
  const [heatChart, setHeatChart] = useState<{
    series: HeatmapSeries[];
    options: ApexOptions;
  }>({
    series: [],
    options: {},
  });

  const filteredData =
    getDashboardDetails?.dealStages?.find(
      (company: any) => company.name === selectedForm
    )?.stages_data || [];

  const chartData: ApexOptions = useMemo(() => {
    const series: number[] =
      filteredData?.map((stage: any) => stage.stage_count) ?? [];
    const labels = filteredData?.map((stage: any) => stage.pipeline_char) ?? [];
    const totalCount = series.reduce(
      (sum: any, val: any) => parseInt(sum) + parseInt(val),
      0
    );
    return {
      series, // Now explicitly a number array
      chart: {
        type: "donut",
        height: 185,
        events: {
          dataPointSelection: async (
            event: any,
            chartContext: any,
            config: any
          ) => {
            const selectedLabel =
              chartData.labels?.[config.dataPointIndex] ?? "Unknown";

            navigate(routes.dealsList, {
              state: {
                selectedLabel: selectedLabel,
                type: "stage",
              },
            });
          },
        },
      },
      labels,
      colors: ["#FFC107", "#0C4B5E", "#AB47BC", "#FD3995"], // Colors from the image
      plotOptions: {
        pie: {
          donut: {
            size: "60%",
            labels: {
              show: true,
              total: {
                show: true,
                label: "Leads",
                formatter: () => `${totalCount}`,
              },
            },
          },
        },
      },
      stroke: {
        lineCap: "round",
        show: true,
        width: 0, // Space between donut sections
        colors: ["#fff"],
      },
      legend: {
        show: false,
      },
      dataLabels: {
        enabled: false,
      },
    };
  }, [filteredData]);

  //New Lead Start
  const newLeadData = async (data: any) => {
    const weekdays = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

    // 1. Group data by week
    const grouped: any = {};
    data.forEach(({ week, day, count }: any) => {
      if (!grouped[week]) {
        grouped[week] = weekdays.map((d) => ({ x: d, y: 0 }));
      }
      const dayEntry = grouped[week].find((d: any) => d.x === day);
      if (dayEntry) dayEntry.y = count;
    });

    // 2. Find top 5 highest values
    const allPoints = Object.values(grouped).flat();
    const sorted = [...allPoints].sort((a: any, b: any) => b.y - a.y);
    const top5 = sorted.slice(0, 5);

    // 3. Add custom color to top 5
    const heatmapSeries = Object.entries(grouped).map(([week, data]: any) => ({
      name: week,
      data: data.map((point: any) => {
        const isTop = top5.some(
          (top: any) => top.x === point.x && top.y === point.y
        );
        return isTop
          ? { ...point, color: "#F37438" } // orange highlight
          : point;
      }),
    }));

    // 4. Set chart config
    setHeatChart({
      series: heatmapSeries,
      options: {
        chart: {
          type: "heatmap",
          height: 300,
        },
        colors: ["#000000"],
        dataLabels: {
          enabled: true,
        },
        xaxis: {
          type: "category",
        },
      },
    });
  };
  //New Lead End
  return (
    <>
      {isLoading && <Loader />}
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Deals Dashboard</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={routes.adminDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Dashboard</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Deals Dashboard
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              <div className="dropdown me-2 mb-2">
                <CommonSelect
                  className="select"
                  options={leadFormChoose}
                  defaultValue={{
                    value: `${formDataFormChoose.pipeline_id}-${formDataFormChoose.form_id}`,
                    label: formDataFormChoose.form_name,
                  }}
                  onChange={handleLeadFormChange}
                />
              </div>
              <div className="dropdown me-2 mb-2">
                <CommonSelect
                  className="select"
                  options={companyChoose}
                  defaultValue={{
                    value: formDataCompanyChoose.companyId,
                    label:
                      formDataCompanyChoose.companyName +
                      "-" +
                      formDataCompanyChoose.companyType,
                  }}
                  onChange={handleCompanyChange}
                />
              </div>
              <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
                <div className="ms-2 head-icons">
                  <CollapseHeader />
                </div>
              </div>
            </div>
          </div>

          {/* First Section */}
          <div className="row">
            <div className="col-xl-3 col-md-6">
              <div
                className="card position-relative"
                onMouseEnter={() => setisHoveredTotalDeal(true)}
                onMouseLeave={() => setisHoveredTotalDeal(false)}
              >
                <div className="card-body">
                  <div className="d-flex align-items-center mb-3">
                    <div
                      className="avatar avatar-md br-10 icon-rotate bg-primary flex-shrink-0"
                      style={{
                        width: "40px",
                        height: "40px",
                        borderRadius: "8px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <i className="ti ti-delta text-white fs-16" />
                    </div>
                    <div className="ms-3">
                      <p className="fw-bold text-dark text-truncate mb-1">
                        Total No of Deals
                      </p>
                      <h5 className="text-primary">
                        <Link
                          to={routes.dealsList}
                          className="btn btn-white border btn-sm d-inline-flex align-items-center"
                        >
                          <i className="ti ti-components me-1" />
                          {getDashboardDetails?.totalDeals}
                        </Link>
                      </h5>
                    </div>
                  </div>

                  {/* Hover Content */}
                  {isHoveredTotalDeal && (
                    <div
                      style={{
                        background: "#F8F9FA",
                        padding: "10px",
                        borderRadius: "8px",
                        marginTop: "10px",
                        transition: "opacity 0.3s ease-in-out",
                      }}
                    >
                      <div className="d-flex justify-content-between">
                        <p className="fw-medium fs-14 mb-0 text-secondary">
                          Last Week:
                        </p>
                        <span className="fs-14 text-danger fw-bold">
                          {getDashboardDetails?.weekStats?.lastWeekDeals}
                        </span>
                      </div>
                      <div className="d-flex justify-content-between mt-2">
                        <p className="fw-medium fs-14 mb-0 text-secondary">
                          This Week:
                        </p>
                        <span className="fs-14 text-primary fw-bold">
                          {getDashboardDetails?.weekStats?.thisWeekDeals}
                        </span>
                      </div>
                      <div className="d-flex justify-content-between mt-2">
                        <p className="fw-medium fs-14 mb-0 text-secondary">
                          Difference:
                        </p>
                        <span
                          className={`fs-14 fw-bold ${
                            getDashboardDetails?.weekStats?.weekDifference > 0
                              ? "text-success"
                              : "text-danger"
                          }`}
                        >
                          {getDashboardDetails?.weekStats?.weekDifference >
                          0 ? (
                            <FaArrowUp style={{ color: "green" }} />
                          ) : (
                            <FaArrowDown />
                          )}{" "}
                          {getDashboardDetails?.weekStats?.weekDifference}
                          {" %"}
                        </span>
                      </div>
                    </div>
                  )}

                  <span className="position-absolute top-0 end-0">
                    <img
                      src="assets/img/bg/card-bg-04.png"
                      alt="Img"
                      style={{ width: "50px", opacity: "0.3" }}
                    />
                  </span>
                </div>
              </div>
            </div>

            <div className="col-xl-3 col-md-6">
              <div
                className="card position-relative"
                onMouseEnter={() => setIsHoveredTodayDeal(true)}
                onMouseLeave={() => setIsHoveredTodayDeal(false)}
              >
                <div className="card-body">
                  <div className="d-flex align-items-center mb-3">
                    <div
                      className="avatar avatar-md br-10 icon-rotate bg-primary flex-shrink-0"
                      style={{
                        width: "40px",
                        height: "40px",
                        borderRadius: "8px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <i className="ti ti-delta text-white fs-16" />
                    </div>
                    <div className="ms-3">
                      <p className="fw-bold text-dark text-truncate mb-1">
                        Today's Deals
                      </p>
                      <h5 className="text-primary">
                        <Link
                          to={routes.dealsList}
                          state={{
                            totalDeals: getDashboardDetails?.totalDeals,
                          }}
                          className="btn btn-white border btn-sm d-inline-flex align-items-center"
                        >
                          <i className="ti ti-components me-1" />
                          {getDashboardDetails?.todayStats?.todayDeals}
                        </Link>
                      </h5>
                    </div>
                  </div>

                  {/* Hover Content */}
                  {isHoveredTodayDeal && (
                    <div
                      style={{
                        background: "#F8F9FA",
                        padding: "10px",
                        borderRadius: "8px",
                        marginTop: "10px",
                        transition: "opacity 0.3s ease-in-out",
                      }}
                    >
                      <div className="d-flex justify-content-between">
                        <p className="fw-medium fs-14 mb-0 text-secondary">
                          Last Week Same Day:
                        </p>
                        <span className="fs-14 text-danger fw-bold">
                          {
                            getDashboardDetails?.todayStats
                              ?.lastWeekSameDayDeals
                          }
                        </span>
                      </div>

                      <div className="d-flex justify-content-between mt-2">
                        <p className="fw-medium fs-14 mb-0 text-secondary">
                          Difference:
                        </p>
                        <span
                          className={`fs-14 fw-bold ${
                            getDashboardDetails?.todayStats?.todayDifference > 0
                              ? "text-success"
                              : "text-danger"
                          }`}
                        >
                          {getDashboardDetails?.todayStats?.todayDifference >
                          0 ? (
                            <FaArrowUp style={{ color: "green" }} />
                          ) : (
                            <FaArrowDown />
                          )}{" "}
                          {getDashboardDetails?.todayStats?.todayDifference}
                          {" %"}
                        </span>
                      </div>
                    </div>
                  )}

                  <span className="position-absolute top-0 end-0">
                    <img
                      src="assets/img/bg/card-bg-04.png"
                      alt="Img"
                      style={{ width: "50px", opacity: "0.3" }}
                    />
                  </span>
                </div>
              </div>
            </div>

            <div className="col-xl-3 col-md-6">
              <div
                className="card position-relative"
                onMouseEnter={() => setisHoveredFollowUp(true)}
                onMouseLeave={() => setisHoveredFollowUp(false)}
              >
                <div className="card-body">
                  <div className="d-flex align-items-center mb-3">
                    <div
                      className="avatar avatar-md br-10 icon-rotate bg-primary flex-shrink-0"
                      style={{
                        width: "40px",
                        height: "40px",
                        borderRadius: "8px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <i className="ti ti-delta text-white fs-16" />
                    </div>
                    <div className="ms-3">
                      <p className="fw-bold text-dark text-truncate mb-1">
                        Today's Follow Up
                      </p>
                      <h5 className="text-primary">
                        <Link
                          to="#"
                          data-bs-toggle="modal"
                          data-bs-target="#follow_up"
                          className="btn btn-white border btn-sm d-inline-flex align-items-center"
                        >
                          <i className="ti ti-components me-1" />
                          {getDashboardDetails?.total_follow_up_today}
                        </Link>
                      </h5>
                    </div>
                  </div>

                  {/* Hover Content */}
                  {isHoveredFollowUp && (
                    <div
                      style={{
                        background: "#F8F9FA",
                        padding: "10px",
                        borderRadius: "8px",
                        marginTop: "10px",
                        transition: "opacity 0.3s ease-in-out",
                      }}
                    >
                      <div className="d-flex justify-content-between mb-3">
                        <p className="fw-medium fs-14 mb-0 text-secondary">
                          Pending
                        </p>
                        <span className="fs-14 text-danger fw-bold">
                          <Link
                            to="#"
                            data-bs-toggle="modal"
                            data-bs-target="#follow_up_pending"
                            className="btn btn-white border btn-sm d-inline-flex align-items-center"
                          >
                            <i className="ti ti-components me-1" />
                            {getDashboardDetails?.total_follow_up_pending}
                          </Link>
                        </span>
                      </div>
                      <div className="d-flex justify-content-between">
                        <p className="fw-medium fs-14 mb-0 text-secondary">
                          Total
                        </p>
                        <span className="fs-14 text-danger fw-bold">
                          <Link
                            to="#"
                            data-bs-toggle="modal"
                            data-bs-target="#follow_up_total"
                            className="btn btn-white border btn-sm d-inline-flex align-items-center"
                          >
                            <i className="ti ti-components me-1" />
                            {getDashboardDetails?.total_follow_up}
                          </Link>
                        </span>
                      </div>
                    </div>
                  )}

                  <span className="position-absolute top-0 end-0">
                    <img
                      src="assets/img/bg/card-bg-04.png"
                      alt="Img"
                      style={{ width: "50px", opacity: "0.3" }}
                    />
                  </span>
                </div>
              </div>
            </div>

            <div className="col-xl-3 col-md-6">
              <div
                className="card position-relative"
                onMouseEnter={() => setisHoveredTotalCall(true)}
                onMouseLeave={() => setisHoveredTotalCall(false)}
              >
                <div className="card-body">
                  <div className="d-flex align-items-center mb-3">
                    <div
                      className="avatar avatar-md br-10 icon-rotate bg-primary flex-shrink-0"
                      style={{
                        width: "40px",
                        height: "40px",
                        borderRadius: "8px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <i className="ti ti-delta text-white fs-16" />
                    </div>
                    <div className="ms-3">
                      <p className="fw-bold text-dark text-truncate mb-1">
                        Today's Calls
                      </p>
                      <h5 className="text-primary">
                        <Link
                          to={routes.callLogs}
                          className="btn btn-white border btn-sm d-inline-flex align-items-center"
                        >
                          <i className="ti ti-components me-1" />
                          {getDashboardDetails?.today_calls}
                        </Link>
                      </h5>
                    </div>
                  </div>

                  {/* Hover Content */}
                  {/* Hover Content */}
                  {isHoveredTotalCall && (
                    <div
                      style={{
                        background: "#F8F9FA",
                        padding: "10px",
                        borderRadius: "8px",
                        marginTop: "10px",
                        transition: "opacity 0.3s ease-in-out",
                      }}
                    >
                      <div className="d-flex justify-content-between">
                        <p className="fw-medium fs-14 mb-0 text-secondary">
                          Last Week Same Day:
                        </p>
                        <span className="fs-14 text-danger fw-bold">
                          {
                            getDashboardDetails?.todayStats
                              ?.lastWeekSameDayDeals
                          }
                        </span>
                      </div>

                      <div className="d-flex justify-content-between mt-2">
                        <p className="fw-medium fs-14 mb-0 text-secondary">
                          Difference:
                        </p>
                        <span
                          className={`fs-14 fw-bold ${
                            getDashboardDetails?.callLogsDetailsSeven > 0
                              ? "text-success"
                              : "text-danger"
                          }`}
                        >
                          {getDashboardDetails?.callPercentageChangeSeven >
                          0 ? (
                            <FaArrowUp style={{ color: "green" }} />
                          ) : (
                            <FaArrowDown />
                          )}{" "}
                          {getDashboardDetails?.callPercentageChangeSeven}
                          {" %"}
                        </span>
                      </div>
                    </div>
                  )}
                  <span className="position-absolute top-0 end-0">
                    <img
                      src="assets/img/bg/card-bg-04.png"
                      alt="Img"
                      style={{ width: "50px", opacity: "0.3" }}
                    />
                  </span>
                </div>
              </div>
            </div>
          </div>
          {/* First Section */}

          {/* /Second Section */}
          <div className="row">
            <div className="col-xl-6">
              <div className="row flex-fill">
                <div className="col-xl-6">
                  <div className="card flex-fill">
                    <div className="card-header">
                      <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-2">
                        <h5>Today's Follow Up Reminder</h5>
                        <div>
                          <Link
                            to="#"
                            data-bs-toggle="modal"
                            data-bs-target="#follow_up"
                            className="btn btn-white border btn-sm d-inline-flex align-items-center"
                          >
                            View All
                          </Link>
                        </div>
                      </div>
                    </div>
                    <div className="card-body">
                      {visibleFollowUps.length > 0 ? (
                        visibleFollowUps.map((list: any, index: number) => (
                          <div
                            key={list.followup_id}
                            className={`d-flex align-items-center justify-content-between ${
                              index !== visibleFollowUps.length - 1
                                ? "mb-4"
                                : ""
                            }`}
                          >
                            <div className="d-flex align-items-center">
                              <input
                                type="checkbox"
                                className="form-check-input me-2"
                                checked={checkedIdsFollowup.includes(
                                  list.followup_id
                                )}
                                onChange={() =>
                                  handleMarkAsDone(list.followup_id)
                                }
                              />
                              <Link to="#" className="avatar flex-shrink-0">
                                <ImageWithBasePath
                                  src="assets/img/users/user-45.jpg"
                                  className="rounded-circle border border-2"
                                  alt="img"
                                />
                              </Link>
                              <div className="ms-2">
                                <h6 className="fs-14 fw-medium text-truncate mb-1">
                                  <Link to="#">
                                    {list.response["Full Name"]}
                                  </Link>
                                </h6>
                                <p className="fs-13">
                                  {list.response["Mobile No"]}
                                </p>
                              </div>
                            </div>
                            <div className="d-flex align-items-center">
                              <p className="fs-13">
                                {list.follow_up_date?.split("T")[0]}
                              </p>
                            </div>
                          </div>
                        ))
                      ) : (
                        <div className="text-center text-muted py-4">
                          No data available
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="col-xl-6">
                  <div className="card flex-fill">
                    <div className="card-header">
                      <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-2">
                        <h5>Pending Follow Up Reminder</h5>
                        <div>
                          <Link
                            to="#"
                            data-bs-toggle="modal"
                            data-bs-target="#follow_up_pending"
                            className="btn btn-white border btn-sm d-inline-flex align-items-center"
                          >
                            View All
                          </Link>
                        </div>
                      </div>
                    </div>
                    <div className="card-body">
                      {visibleFollowUpsPending.length > 0 ? (
                        visibleFollowUpsPending.map(
                          (list: any, index: number) => (
                            <div
                              key={list.followup_id}
                              className={`d-flex align-items-center justify-content-between ${
                                index !== visibleFollowUpsPending.length - 1
                                  ? "mb-4"
                                  : ""
                              }`}
                            >
                              <div className="d-flex align-items-center">
                                <input
                                  type="checkbox"
                                  className="form-check-input me-2"
                                  checked={checkedIdsPending.includes(
                                    list.followup_id
                                  )}
                                  onChange={() =>
                                    handleMarkAsDonePending(list.followup_id)
                                  }
                                />
                                <Link to="#" className="avatar flex-shrink-0">
                                  <ImageWithBasePath
                                    src="assets/img/users/user-45.jpg"
                                    className="rounded-circle border border-2"
                                    alt="img"
                                  />
                                </Link>
                                <div className="ms-2">
                                  <h6 className="fs-14 fw-medium text-truncate mb-1">
                                    <Link to="#">
                                      {list.response["Full Name"]}
                                    </Link>
                                  </h6>
                                  <p className="fs-13">
                                    {list.response["Mobile No"]}
                                  </p>
                                </div>
                              </div>
                              <div className="d-flex align-items-center">
                                <p className="fs-13">
                                  {list.follow_up_date?.split("T")[0]}
                                </p>
                              </div>
                            </div>
                          )
                        )
                      ) : (
                        <div className="text-center text-muted py-4">
                          No data available
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-xl-6">
              <div className="card flex-fill">
                <div className="card-header">
                  <div className="d-flex align-items-center justify-content-between">
                    <h5>Pipeline Stages</h5>
                    <div className="d-flex flex-wrap gap-2">
                      {/* Company Dropdown */}

                      {/* Year Dropdown */}
                      {/* <div className="dropdown">
                        <Link
                          to="#"
                          className="btn btn-white border btn-sm d-inline-flex align-items-center"
                          data-bs-toggle="dropdown"
                        >
                          <i className="ti ti-calendar me-1" />
                          {selectedYear}
                        </Link>
                        <ul className="dropdown-menu dropdown-menu-end p-3">
                          {yearRanges.map((range, index) => (
                            <li key={index}>
                              <Link
                                to="#"
                                className="dropdown-item rounded-1"
                                onClick={() => setSelectedYear(range)}
                              >
                                {range}
                              </Link>
                            </li>
                          ))}
                        </ul>
                      </div> */}
                    </div>
                  </div>
                </div>
                <div className="card-body">
                  <ReactApexChart
                    id="pipeline_chart"
                    options={pipeline_chart}
                    series={pipeline_chart.series}
                    type="bar"
                    height={280}
                  />
                  <div>
                    <h6 className="mb-3">Deals Values By Stages</h6>
                    <div className="row g-2 justify-content-center">
                      {pipelineStagesData?.map((stage: any, idx: any) => (
                        <div className="col-md col-sm-4 col-6" key={idx}>
                          <div className="border rounded text-center p-2">
                            <p className="mb-1">
                              <i className="ti ti-point-filled text-primary" />{" "}
                              {stage}
                            </p>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* /Second Section */}

          {/* /Third Section */}
          <div className="row">
            <div className="col-xl-8 d-flex">
              <div className="card flex-fill">
                <div className="card-header">
                  <div className="d-flex justify-content-between align-items-center flex-wrap mb-3">
                    <h5 className="mb-0">Deals by Stage</h5>
                    <div className="d-flex flex-wrap gap-2">
                      {/* Company Dropdown */}
                      {/* Year Dropdown */}
                      <div className="dropdown">
                        <Link
                          to="#"
                          className="btn btn-white border btn-sm d-inline-flex align-items-center"
                          data-bs-toggle="dropdown"
                        >
                          <i className="ti ti-calendar me-1" />
                          {selectedYear}
                        </Link>
                        <ul className="dropdown-menu dropdown-menu-end p-3">
                          {yearRanges.map((range, index) => (
                            <li key={index}>
                              <Link
                                to="#"
                                className="dropdown-item rounded-1"
                                onClick={() => setSelectedYear(range)}
                              >
                                {range}
                              </Link>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-body pb-0">
                  {/* Pipeline Stages Section */}
                  <div className="mb-3">
                    {isLoadingStagesYear ? (
                      <div className="text-center w-100 py-4">
                        <div
                          className="spinner-border text-primary"
                          role="status"
                          style={{ width: "1.5rem", height: "1.5rem" }}
                        >
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      </div>
                    ) : filteredDataStagesYear?.length > 0 ? (
                      <>
                        <div className="row g-2 justify-content-start">
                          {visibleStages.map((stage: any, index: any) => {
                            const color =
                              revenueIncome?.colors?.[index] ||
                              revenueIncome?.options?.colors?.[index] ||
                              "#007bff";

                            return (
                              <div
                                key={index}
                                className="col-xl-2 col-md-3 col-sm-4 col-6"
                              >
                                <div
                                  className="small-card rounded p-2 text-center shadow-sm h-100 position-relative"
                                  style={{
                                    border: `1px solid ${color}`,
                                    minHeight: 80,
                                    fontSize: "13px",
                                  }}
                                >
                                  <p
                                    className="mb-1 stage-name"
                                    title={stage.pipeline_char}
                                  >
                                    <i
                                      className="ti ti-point-filled me-1"
                                      style={{ color }}
                                    />
                                    {stage.pipeline_char}
                                  </p>
                                  <h6
                                    className="mb-0 fw-semibold"
                                    style={{ fontSize: "14px" }}
                                  >
                                    {stage.stage_count}
                                  </h6>
                                </div>
                              </div>
                            );
                          })}
                        </div>

                        {filteredDataStagesYear.length > MAX_VISIBLE_CARDS && (
                          <div className="text-center mt-2">
                            <button
                              className="btn btn-link text-primary fw-medium"
                              onClick={() => setShowAllStages(!showAllStages)}
                            >
                              {showAllStages ? "Show Less" : "View All"}
                            </button>
                          </div>
                        )}
                      </>
                    ) : (
                      <div className="text-center text-muted">
                        No data available
                      </div>
                    )}
                  </div>

                  {/* Bar Chart */}
                  {revenueIncome && revenueIncome.series?.length > 0 ? (
                    <ReactApexChart
                      id="revenue-income"
                      options={revenueIncome}
                      series={revenueIncome.series}
                      type="bar"
                      height={230}
                    />
                  ) : (
                    <div className="text-center text-muted">
                      No chart data available
                    </div>
                  )}

                  {/* Inline Styles */}
                  <style>
                    {`
                  .stage-name {
                    font-size: 12px;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: inline-block;
                    max-width: 100%;
                    vertical-align: middle;
                  }
            
                  .small-card {
                    transition: box-shadow 0.2s ease;
                  }
            
                  .small-card:hover {
                    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
                  }
                `}
                  </style>
                </div>
              </div>
            </div>

            <div className="col-xl-4 d-flex">
              <div className="card flex-fill">
                <div className="card-header">
                  <div className="d-flex align-items-center justify-content-between flex-wrap">
                    <h5>Recent Activites</h5>
                    <div>
                      <Link
                        to="#"
                        data-bs-toggle="modal"
                        data-bs-target="#recent_activity"
                        className="btn btn-white border btn-sm d-inline-flex align-items-center"
                      >
                        View All
                      </Link>
                    </div>
                  </div>
                </div>
                <div className="card-body">
                  {visibleRecentActivity?.length > 0 ? (
                    visibleRecentActivity?.map((list: any, index: number) => (
                      <div
                        key={list.id}
                        className={`d-flex align-items-center justify-content-between ${
                          index !== visibleRecentActivity.length - 1
                            ? "mb-4"
                            : ""
                        }`}
                      >
                        <div className="d-flex">
                          <Link
                            to={routes.dealsList}
                            state={{
                              details: list.lead_id,
                            }}
                            className="d-inline-flex"
                          >
                            <i className="ti ti-point-filled text-primary" />
                            <div className="ms-2">
                              <h6 className="fs-14 fw-medium text-truncate mb-1">
                                {list?.title}
                              </h6>
                              <p className="fs-13">{list?.detail}</p>
                            </div>
                          </Link>
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="text-center text-muted py-4">
                      No data available
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          {/* /Third Section */}

          {/* /Fourth Section */}

          <div className="row">
            <div className="col-xl-8 d-flex">
              <div className="card flex-fill">
                <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-2">
                  <h5>Recent Leads</h5>
                  <div className="d-flex align-items-center">
                    <div>
                      <Link
                        to={routes.dealsList}
                        className="btn btn-white border btn-sm d-inline-flex align-items-center"
                      >
                        View All
                      </Link>
                    </div>
                  </div>
                </div>
                <div className="card-body p-0">
                  <div className="table-responsive">
                    <table className="table table-nowrap dashboard-table mb-0">
                      <thead>
                        <tr>
                          <th>Lead Name</th>
                          <th>Company Name</th>
                          <th>Mobile No</th>
                          <th>Stage</th>
                          <th>Created Date</th>
                        </tr>
                      </thead>
                      <tbody>
                        {leadData?.length > 0 ? (
                          leadData?.map((lead: any) => (
                            <tr key={lead.key}>
                              <td>
                                <h6 className="fw-medium">
                                  <Link to="#">
                                    {lead.response["Full Name"]}
                                  </Link>
                                </h6>
                              </td>
                              <td>
                                <div className="d-flex align-items-center file-name-icon">
                                  <Link
                                    to="#"
                                    className="avatar border rounded-circle"
                                  >
                                    <ImageWithBasePath
                                      src={lead.Logo}
                                      className="img-fluid"
                                      alt="img"
                                    />
                                  </Link>
                                  <div className="ms-2">
                                    <h6 className="fw-medium">
                                      <Link to="company-details.html">
                                        {getAbbreviation(lead.company_name)}
                                      </Link>
                                    </h6>
                                  </div>
                                </div>
                              </td>
                              <td>
                                <span
                                  className={`d-inline-flex align-items-center`}
                                >
                                  {lead.Phone}
                                </span>
                              </td>
                              <td>
                                <span
                                  className={`d-inline-flex align-items-center`}
                                >
                                  <i className="ti ti-point-filled me-1" />
                                  {lead.pipeline_char}
                                </span>
                              </td>
                              <td>
                                {" "}
                                {moment(lead.createdAt).format(
                                  "DD-MM-YYYY HH:mm:ss"
                                )}
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td
                              colSpan={5}
                              className="text-center text-muted py-3"
                            >
                              No leads available
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            {/* New Leads Heatmap */}
            <div className="col-xl-4 d-flex">
              <div className="card flex-fill">
                <div className="card-header">
                  <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-2">
                    <h5>New Deals</h5>
                  </div>
                </div>
                <div className="card-body pb-0">
                  {heatChart?.series?.length > 0 ? (
                    <ReactApexChart
                      id="heat_chart"
                      options={heatChart.options}
                      series={heatChart.series}
                      type="heatmap"
                      height={300}
                    />
                  ) : (
                    <div className="text-center text-muted">
                      No heatmap data available
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* /Fourth Section */}
        </div>
        <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
          <p className="mb-0">2025 © {company_short_name}</p>
          <p>
            Designed & Developed By{" "}
            <Link to="#" className="text-primary">
              {company_short_name}
            </Link>
          </p>
        </div>
      </div>
      {/* /Page Wrapper */}
      <div className="modal fade" id="follow_up">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Follow Up Reminder</h4>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  updateUI();
                }}
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <form>
              <div className="modal-body pb-0">
                <div className="row">
                  {visibleFollowUpsAll?.length > 0 ? (
                    visibleFollowUpsAll?.map((list: any, index: number) => (
                      <div
                        key={list.followup_id}
                        className={`d-flex align-items-center justify-content-between ${
                          index !== visibleFollowUpsAll?.length - 1
                            ? "mb-4"
                            : ""
                        }`}
                      >
                        <div className="d-flex align-items-center">
                          <input
                            type="checkbox"
                            className="form-check-input me-2"
                            checked={checkedIdsFollowup.includes(
                              list.followup_id
                            )}
                            onChange={() =>
                              handleMarkAsDoneAll(list.followup_id)
                            }
                          />
                          <Link to="#" className="avatar flex-shrink-0">
                            <ImageWithBasePath
                              src="assets/img/users/user-45.jpg"
                              className="rounded-circle border border-2"
                              alt="img"
                            />
                          </Link>
                          <div className="ms-2">
                            <h6 className="fs-14 fw-medium text-truncate mb-1">
                              <Link to="#">{list.response["Full Name"]}</Link>
                            </h6>
                            <p className="fs-13">
                              {list.response["Mobile No"]}
                            </p>
                          </div>
                        </div>
                        <div className="d-flex align-items-center">
                          <p className="fs-13">
                            {list.follow_up_date?.split("T")[0]}
                          </p>
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="text-center text-muted py-4">
                      No data available
                    </div>
                  )}
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-light me-2"
                  data-bs-dismiss="modal"
                  onClick={() => {
                    updateUI();
                  }}
                >
                  Close
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div className="modal fade" id="follow_up_total">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Total Follow Up Reminder</h4>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  updateUI();
                }}
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <form>
              <div className="modal-body pb-0">
                <div className="row">
                  {visibleFollowUpsTotal?.length > 0 ? (
                    visibleFollowUpsTotal?.map((list: any, index: number) => (
                      <div
                        key={list.followup_id}
                        className={`d-flex align-items-center justify-content-between ${
                          index !== visibleFollowUpsTotal?.length - 1
                            ? "mb-4"
                            : ""
                        }`}
                      >
                        <div className="d-flex align-items-center">
                          <Link to="#" className="avatar flex-shrink-0">
                            <ImageWithBasePath
                              src="assets/img/users/user-45.jpg"
                              className="rounded-circle border border-2"
                              alt="img"
                            />
                          </Link>
                          <div className="ms-2">
                            <h6 className="fs-14 fw-medium text-truncate mb-1">
                              <Link to="#">{list.response["Full Name"]}</Link>
                            </h6>
                            <p className="fs-13">
                              {list.response["Mobile No"]}
                            </p>
                          </div>
                        </div>
                        <div className="d-flex align-items-center">
                          <p className="fs-13">
                            {list.follow_up_date?.split("T")[0]}
                          </p>
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="text-center text-muted py-4">
                      No data available
                    </div>
                  )}
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-light me-2"
                  data-bs-dismiss="modal"
                  onClick={() => {
                    updateUI();
                  }}
                >
                  Close
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div className="modal fade" id="follow_up_pending">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Pending Follow Up Reminder</h4>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  updateUI();
                }}
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <form>
              <div className="modal-body pb-0">
                <div className="row">
                  {visibleFollowUpsPendingAll?.length > 0 ? (
                    visibleFollowUpsPendingAll?.map(
                      (list: any, index: number) => (
                        <div
                          key={list.followup_id}
                          className={`d-flex align-items-center justify-content-between ${
                            index !== visibleFollowUpsPendingAll?.length - 1
                              ? "mb-4"
                              : ""
                          }`}
                        >
                          <div className="d-flex align-items-center">
                            <input
                              type="checkbox"
                              className="form-check-input me-2"
                              checked={checkedIdsFollowup.includes(
                                list.followup_id
                              )}
                              onChange={() =>
                                handleMarkAsDonePendingAll(list.followup_id)
                              }
                            />
                            <Link to="#" className="avatar flex-shrink-0">
                              <ImageWithBasePath
                                src="assets/img/users/user-45.jpg"
                                className="rounded-circle border border-2"
                                alt="img"
                              />
                            </Link>
                            <div className="ms-2">
                              <h6 className="fs-14 fw-medium text-truncate mb-1">
                                <Link to="#">{list.response["Full Name"]}</Link>
                              </h6>
                              <p className="fs-13">
                                {list.response["Mobile No"]}
                              </p>
                            </div>
                          </div>
                          <div className="d-flex align-items-center">
                            <p className="fs-13">
                              {list.follow_up_date?.split("T")[0]}
                            </p>
                          </div>
                        </div>
                      )
                    )
                  ) : (
                    <div className="text-center text-muted py-4">
                      No data available
                    </div>
                  )}
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-light me-2"
                  data-bs-dismiss="modal"
                  onClick={() => {
                    updateUI();
                  }}
                >
                  Close
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div className="modal fade" id="recent_activity">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">All Activity</h4>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  updateUI();
                }}
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <form>
              <div className="modal-body pb-0">
                <div className="row">
                  {visibleRecentActivityAll?.length > 0 ? (
                    visibleRecentActivityAll?.map(
                      (list: any, index: number) => (
                        <div
                          key={list.id}
                          className={`d-flex align-items-center justify-content-between ${
                            index !== visibleRecentActivityAll.length - 1
                              ? "mb-4"
                              : ""
                          }`}
                        >
                          <div className="d-flex">
                            <Link
                              to={routes.dealsList}
                              state={{
                                details: list.lead_id,
                              }}
                              className="d-inline-flex"
                            >
                              <i className="ti ti-point-filled text-primary" />
                              <div className="ms-2">
                                <h6 className="fs-14 fw-medium text-truncate mb-1">
                                  {list?.title}
                                </h6>
                                <p className="fs-13">{list?.detail}</p>
                              </div>
                            </Link>
                          </div>
                        </div>
                      )
                    )
                  ) : (
                    <div className="text-center text-muted py-4">
                      No data available
                    </div>
                  )}
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-light me-2"
                  data-bs-dismiss="modal"
                  onClick={() => {
                    updateUI();
                  }}
                >
                  Close
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default DealsDashboard;
